webpackJsonp([35783957827783],{

/***/ 139:
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ 404:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(107);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(404);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LessonCard = function LessonCard(_ref) {
	  var content = _ref.content,
	      title = _ref.title;
	  return _react2.default.createElement(
	    "div",
	    { className: "main-card" },
	    _react2.default.createElement(
	      "h1",
	      { className: "lesson-title gradient" },
	      title
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "lesson-content" },
	      _react2.default.createElement(
	        "ol",
	        null,
	        content.map(function (lesson) {
	          return _react2.default.createElement(
	            "li",
	            { key: lesson.node.frontmatter.path },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: lesson.node.frontmatter.path },
	              lesson.node.frontmatter.title
	            )
	          );
	        })
	      )
	    )
	  );
	};
	
	exports.default = LessonCard;
	module.exports = exports["default"];

/***/ }),

/***/ 406:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TOCCard = __webpack_require__(316);
	
	var _TOCCard2 = _interopRequireDefault(_TOCCard);
	
	var _gatsbyLink = __webpack_require__(107);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(406);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "index" },
	    _react2.default.createElement(
	      "div",
	      { className: "jumbotron gradient" },
	      _react2.default.createElement(
	        "h1",
	        null,
	        "Intro to Web Dev"
	      ),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "v2 - ",
	        _react2.default.createElement(
	          "a",
	          { href: "https://frontendmasters.com/courses/web-development-v2/" },
	          "Videos on Frontend Masters"
	        )
	      )
	    ),
	    _react2.default.createElement(_TOCCard2.default, {
	      title: "Table of Contents",
	      content: props.data.allMarkdownRemark.edges
	    })
	  );
	};
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";
	
	exports.default = IndexPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-f43f6bfc73365bb2432f.js